import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  copyResetTimeout;

  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copiedLabel = this.getAttribute('copied-label');
    const button = this.querySelector('button');

    if (copiedLabel && button instanceof HTMLButtonElement) {
      const initialLabel = button.getAttribute('aria-label');

      this.toggleAttribute('copied', true);
      button.setAttribute('aria-label', copiedLabel);
      clearTimeout(this.copyResetTimeout);

      this.copyResetTimeout = setTimeout(() => {
        this.toggleAttribute('copied', false);

        if (initialLabel) {
          button.setAttribute('aria-label', initialLabel);
        }
      }, 1600);
    }
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
